export const validation = {
  noSpace: "No blank space is allowed at start and end",
  onlySpaces: "Invalid text",
  minCharacters: "Minimum 3 character is required ",
  enter50Char: "please enter less than 50 character",
};
